'use client';

import useDenaliToggleMode from '@alltrails/denali/hooks/useDenaliToggleMode';

export default function DenaliToggleMode() {
  useDenaliToggleMode();
  return null;
}
